goog.provide("shadow.js.shim.module$react_use$lib$useCopyToClipboard");
goog.provide("module$shadow_js_shim_module$react_use$lib$useCopyToClipboard");
shadow.js.shim.module$react_use$lib$useCopyToClipboard = shadow.js.nativeProvides["react-use/lib/useCopyToClipboard"] = shadow$bridge("react-use/lib/useCopyToClipboard");
module$shadow_js_shim_module$react_use$lib$useCopyToClipboard.default = shadow.js.shim.module$react_use$lib$useCopyToClipboard;
